import { render, staticRenderFns } from "./category1.vue?vue&type=template&id=6c5048de"
import script from "./category1.vue?vue&type=script&lang=js"
export * from "./category1.vue?vue&type=script&lang=js"
import style0 from "./category1.vue?vue&type=style&index=0&id=6c5048de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports